import React from "react";

import { TailwindSelect } from "../../Tailwind";
import { useUpdateFieldValue } from "../../../shared/hooks/mutations/useUpdateFieldValue";
import { useSaveIndicator } from "../../../hooks/useSaveIndicator";
import SaveIndicator from "../../SaveIndicator";
import FieldError from "../FieldError";
import { useEditorStore } from "../../../shared/stores/useEditorStore";
import snakeToPascal from "../../../tools";

export default function EnumField({ name, field, onFieldChange }: { name: string; field: any; onFieldChange?: () => void }) {
    const [mounted, setMounted] = React.useState(false);
    const { status: saveStatus, trigger: triggerSave, resolve: resolveSave } = useSaveIndicator();
    const updateField = useUpdateFieldValue();
    const isReadOnly = !useEditorStore(s => s.userRights.right_to_write);
    const scenarioId = useEditorStore(s => s.scenarioId);

    const reloadLocalState = () => {
        setMounted(!mounted);
    }

    const onChange = (value) => {
        field.compute_error = null;
        const apiValue = value || null;

        // Optimistic update for immediate conditional visibility
        field.currentValue.value = apiValue;
        reloadLocalState();
        onFieldChange?.();

        triggerSave();
        updateField.mutate(
            { id: field.id, value: apiValue, scenarioId: scenarioId ?? 0 },
            {
                onSuccess: () => {
                    resolveSave();
                },
            }
        );
    }

    // Display-only formatting: the submitted/stored value stays the canonical enum key
    // (used by visible_if matching and backend compute dispatch); only the label is prettified.
    const options = field.choices.map(choice => ({
        value: choice,
        label: snakeToPascal(choice),
    }));

    // Gérer le cas où currentValue est undefined (nouveau model data)
    const currentValue = field.currentValue?.value || field.value?.value || '';

    return (
        <div>
            <div className="flex flex-row items-center">
                <TailwindSelect
                    value={currentValue}
                    onChange={onChange}
                    options={options}
                    placeholder={name}
                    disabled={isReadOnly}
                    className="min-w-[200px]"
                    autoWidth
                />
                <SaveIndicator status={saveStatus} className="ml-2" />
            </div>
            <FieldError field={field} />
        </div>
    );
}
